import axios from '../utils/axios'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

export type VerifyResponse = AxiosResponse<{
  data: {
    token_use: string
    scope: string
    iat: number
    username: string
    exp: string
  }
}>

const VERIFY_SESSION_URL = process.env.REACT_APP_VERIFY_SESSION as string

export async function verifySession(
  username: string,
  accessToken: string,
  isSSO?: boolean
): Promise<VerifyResponse> {
  try {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: VERIFY_SESSION_URL,
      data: { accessToken, username },
      headers: isSSO ? { 'x-source': 'sso' } : undefined,
    }

    const verifyUserResponse = await axios(config)
    return verifyUserResponse
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw error.response ?? error
    }
    throw error
  }
}
